import React, { Dispatch, useState, useEffect, useLayoutEffect } from 'react'
import { Menu } from 'antd'
import {
  HomeOutlined,
  UnorderedListOutlined,
  LogoutOutlined,
  UserAddOutlined,
  PlusCircleOutlined,
  LineChartOutlined,
  FormOutlined
} from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import './sideBar.css'
import { useUserContext } from "../../userContext"
import { getCountCurrentBP } from '../../api/BPTable/BPTableMethods'
import logo from "./../../assets/image003.jpeg"
import { logout } from '../../api/User/LoginMethod'

// eslint-disable-next-line camelcase

function SideBar(props: { setOpen: Dispatch<boolean>, open: boolean }) {
  const { setOpen, open } = props
  const [selected, setSelected] = useState<string>('')
  const [count, setCount] = useState<{ count: number }>({ count: 0 })
  const { user } = useUserContext()
  let navigate = useNavigate()
  let location = useLocation()

  useLayoutEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
  }, [open])

  const handleClick = async (key: string, keyPath: string[]) => {
    if (key === "version") return
    if (key === 'logout') {
      await logout(localStorage.getItem("token"))
      localStorage.clear();
      return navigate('/login')
    }
    navigate('/' + key)
    setOpen(false)
  }

  useEffect(() => {
    getCount()
  }, [])

  useEffect(() => {
    if (location.pathname) {
      setSelected(location.pathname.replace('/', ''))
    }
    if (location.pathname.split("/")[1] !== 'scanning')
      sessionStorage.removeItem("result")
  }, [location])

  const getCount = async () => {
    const res: any = await getCountCurrentBP(["PENDING"])
    setCount(res)
  }

  const getWindowScreen = () => {
    const screenWidth = window.screen.width
    if (screenWidth <= 830) { return '50vw' } else { return '33vw' }
  }

  const items_user = [
    {
      label: '',
      id: 'logo',
      key: 'logo',
      icon: <img src={logo} alt="logo" className="menu-logo" />,
      disabled: true
    },
    {
      type: 'divider',
      key: 'divider'
    },
    {
      label: <span className='menu-label'>En cours</span>,
      key: 'home',
      icon: <HomeOutlined className='icon-menu' />,
      id: 'home'
    },
    {
      label: <span className='menu-label menu-label-inventory'>Tous BP<div className='colored-rounded-number'>{count.count} en attente</div>
      </span>,
      key: 'inventory',
      icon: <UnorderedListOutlined className='icon-menu' />,
      id: 'inventory'
    },
    {
      label: <span className='menu-label'>Se déconnecter</span>,
      key: 'logout',
      icon: <LogoutOutlined className='icon-menu' />,
      id: 'disconnect-button'
    },
    {
      label: <span style={{ bottom: 0, position: "absolute", fontSize: "0.8rem", color: "grey" }}>{`Version ${process.env.REACT_APP_VERSION}`} </span>,
      key: "version",
      id: "version",
    }
  ]

  const items_admin = [
    {
      icon: <img src={logo} alt="logo" className="menu-logo" />,
      key: 'logo',
      disabled: true
    },
    {
      type: 'divider',
      key: 'divider'
    },
    {
      label: <span className='menu-label'>En cours</span>,
      key: 'home',
      icon: <HomeOutlined className='icon-menu' />,
      id: 'home'
    },
    {
      label: <span className='menu-label menu-label-inventory'>Tous BP<div className='colored-rounded-number'>{count.count} en attente</div>
      </span>,
      key: 'inventory',
      icon: <UnorderedListOutlined className='icon-menu' />,
      id: 'inventory'
    },
    {
      label: <span className='menu-label'>Rapport d'activité</span>,
      key: 'activity_report',
      icon: <LineChartOutlined className='icon-menu' />,
      id: 'activity_report'
    },
    {
      label: <span className='menu-label'>Ajouter un BP</span>,
      key: 'add_bp',
      icon: <PlusCircleOutlined className='icon-menu' />,
      id: 'add_bp'
    },
    {
      label: <span className='menu-label'>Collaborateurs</span>,
      key: 'add_user',
      icon: <UserAddOutlined className='icon-menu' />,
      id: 'collaborator'
    },
    {
      label: <span className='menu-label'>Référentiel</span>,
      key: 'reference',
      icon: <FormOutlined className='icon-menu' />,
      id: 'reference'
    },
    {
      label: <span className='menu-label'>Se déconnecter</span>,
      key: 'logout',
      icon: <LogoutOutlined className='icon-menu' />,
      id: 'logout'
    },
    {
      label: <span style={{ bottom: 0, position: "absolute", fontSize: "0.8rem", color: "grey" }}>{`Version ${process.env.REACT_APP_VERSION}`} </span>,
      key: "version",
      id: "version",
    }
  ]

  console.log("user", user)

  return (
    <Drawer
      direction="left"
      open={open}
      onClose={() => setOpen(false)}
      size={getWindowScreen()}
    >
      <Menu
        defaultSelectedKeys={['home']}
        selectedKeys={[selected]}
        inlineIndent={20}
        onClick={({ key, keyPath }) => handleClick(key, keyPath)}
        className='side-bar-main'
        mode='vertical'
        items={user && user?.group === 'admin' ? items_admin : items_user} >
      </Menu>
    </Drawer>
  )
}

export default SideBar